export var menuElementDefaultTheme = {
  Root: {
    base: {
      $typography: 'labelLarge',
      color: '$color.neutral.06',
      backgroundColor: '$color.neutral.00',
      paddingLeft: 6,
      paddingRight: 6,
      '&:before': {
        backgroundColor: '$color.primary.main'
      },
      '&:hover': {
        '&:before': {
          width: 1
        },
        backgroundColor: '$color.primary.lightest'
      }
    },
    secondary: {
      paddingLeft: 16,
      $typography: 'paragraphLarge',
      backgroundColor: '$color.neutral.01'
    },
    tertiary: {
      paddingLeft: 20,
      $typography: 'paragraphLarge',
      backgroundColor: '$color.neutral.01'
    },
    selected: {
      '&:before': {
        width: 1
      },
      backgroundColor: '$color.primary.lightest'
    }
  },
  ExpanseHandle: {
    base: {
      padding: 4,
      paddingTop: 5
    },
    primary: {
      color: '$color.primary.main'
    }
  },
  ExpanseHandleArrow: {
    base: {}
  },
  Content: {
    base: {
      paddingTop: 4,
      paddingBottom: 4
    }
  }
};